






























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType: string = "finance/getSettlements";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "申请时间", dataIndex: "created_time" },
    { title: "金额", scopedSlots: { customRender: "earning" } },
    { title: "状态", scopedSlots: { customRender: "audit_status" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }
}
